import Vue from 'vue';
import Router from 'vue-router';
// import VueRouter from 'vue-router';

import LoginPage from '@/components/LoginPage.vue';
import OtpPage from '@/components/OtpPage.vue';
import menuSelection from '@/components/menuSelection.vue';
import initial_info from '@/components/initial_info.vue';

import liveness_landingPage from '@/components/liveness_landingPage.vue';
import livenessCheck from '@/components/livenessCheck.vue';
import kycPage from '@/components/kycPage.vue';

import homedataform from '@/components/homedataform.vue';
import ForgotPassword from '@/components/ForgotPassword.vue';
import setNewPassword from '@/components/setNewPassword.vue';

import ChangePasswordPage from '@/components/ChangePasswordPage.vue';
import Saveddataform from '@/components/saveddataform.vue';
import SessionTimeout from '@/components/SessionTimeout.vue';

Vue.use(Router);
// Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'LoginPage',
    component: LoginPage 
  },
  {
    path: '/otp',
    name: 'otpPage',
    component: OtpPage
  },
  {
    path: '/menuSelection',
    name: 'menuSelection',
    component: menuSelection
  },
  
//   {
//     path: '/ChangePasswordPage',
//     name: 'ChangePasswordPage',
//     component: ChangePasswordPage
//   },
  {
    path: '/initial_info',
    name: 'initial_info',
    component: initial_info
  },
  {
    path: '/liveness_landingPage',
    name: 'liveness_landingPage',
    component: liveness_landingPage
  },
  {
    path: '/livenessCheck',
    name: 'livenessCheck',
    component: livenessCheck
  },
  {
    path: '/kycPage',
    name: 'kycPage',
    component: kycPage
  },

  {
    path: '/homedataform',
    name: 'HomeDataForm',
    component: homedataform
  }, 
  {
    path: '/ForgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/setNewPassword',
    name: 'setNewPassword',
    component: setNewPassword
  },
  {
    path: '/ChangePasswordPage',
    name: 'ChangePasswordPage',
    component: ChangePasswordPage
  },
  {
    path: '/dataforms/:surveyID/:IsSaved',
    name: 'dataforms',
    component: Saveddataform
  },
  {
    path: '/SessionTimeout',
    name: 'SessionTimeout',
    component: SessionTimeout
  }
];

// const router = new VueRouter({
//   mode: 'history',  // Enable history mode
//   routes
// });



const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes
});


// router.beforeEach((to, from, next) => {
//   if (to.name === null) {
//     // If the route is not recognized, redirect to home page
//     next({ name: 'LoginPage' });
//   } else {
//     next();
//   }
// });
router.beforeEach((to, from, next) => {
  if (!to.name && to.path !== '/') {
    console.log("Redirecting to 'initial_info' due to unrecognized route");
    next({ name: 'LoginPage', replace: true });
  } else {
    next(); // Allow navigation to recognized routes
  }
  
});

// let confirmNavigation = true; // Flag to control navigation confirmation

// router.beforeEach((to, from, next) => {
//   if (confirmNavigation && from.name !== 'Login' && to.name !== 'Login') {
//     // Check if navigation away from the login page
//     if (window.confirm('Are you sure you want to leave this page?')) {
//       // If user confirms, proceed to the next route
//       next();
//     } else {
//       // If user cancels, stay on the current route
//       next(false);
//     }
//   } else {
//     // If navigating to or from the login page, proceed without confirmation
//     next();
//   }
// });



// Override the push method to catch NavigationDuplicated errors
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => {
    if (Router.isNavigationFailure(err, Router.NavigationFailureType.duplicated)) {
      return err;
    }
    return Promise.reject(err);
  });
};

// Override the replace method to catch NavigationDuplicated errors
const originalReplace = Router.prototype.replace;
// Router.prototype.replace = function replace(location, onResolve, onReject) {
//   if (onResolve || onReject) {
//     return originalReplace.call(this, location, onResolve, onReject);
//   }
//   return originalReplace.call(this, location).catch(err => {
//     if (Router.isNavigationFailure(err, Router.NavigationFailureType.duplicated)) {
//       return err;
//     }
//     return Promise.reject(err);
//   });
// }

Router.prototype.replace = function replace(location, onResolve, onReject) {
  console.log('Replacing location:', location);  // Log location to debug
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch(err => {
    console.log('Error during navigation:', err);  // Log any error encountered
    if (Router.isNavigationFailure(err, Router.NavigationFailureType.duplicated)) {
      return err;
    }
    return Promise.reject(err);
  });
};



export default router;
